<template>
  <!--***-->
  <div
    class="rounded-lg mx-4 mt-2"
    :id="'item' + item.ean"
    style="scroll-margin-top: 50px;"
  >
    <v-card
      id="itemCard"
      class="align-center text-start px-0"
      elevation="0"
      v-bind:style="this.productCardStyle"
      color="product_card"
    >
      <v-card-text class="pa-0 px-0 ma-0 mx-0" @click="setCurrent">
        <!--***-->
        <v-list-item three-line class="mx-0">
          <v-list-item-content>
            <v-list-item-title
              class="font-weight-bold mb-0 text-lg-h6 product_name--text "
            >
              {{ item.name }}
            </v-list-item-title>

            <v-list-item-subtitle
              v-if="!hideProductDescriptionInMenu"
              class="product_description--text item_description"
            >
              <span
                class="mt-3"
                style="font-size: 10pt !important;"
                v-html="item.description"
              ></span>
            </v-list-item-subtitle>

            <div v-if="parseFloat(this.itemDiscount) > 0">
              <div class="d-flex align-middle">
                <span class="product_price--text" id="discounted">{{
                  (item.finalizedPrice + itemDeposit) | currency
                }}</span>
                <span class="ml-2" id="oldPrice">{{
                  (item.taxedPrice + itemDeposit) | currency
                }}</span>
              </div>
              <span v-if="itemDeposit > 0" class="text-caption text-muted">
                {{ $t("generic.lang_includeDeposit") }}
                {{ itemDeposit | currency }}
              </span>
            </div>
            <div v-else>
              <h6 class="pt-2 product_price--text">
                {{ (item.taxedPrice + itemDeposit) | currency }}
              </h6>
              <span v-if="itemDeposit > 0" class="text-caption text-muted">
                {{ $t("generic.lang_includeDeposit") }}
                {{ itemDeposit | currency }}
              </span>
            </div>

            <div>
              <v-btn
                v-if="!this.hideProductDetails"
                @click.stop="details"
                class="accent--text"
                icon
              >
                <v-icon>mdi-information</v-icon>
              </v-btn>
            </div>
          </v-list-item-content>

          <v-list-item-avatar tile size="80">
            <v-img
              v-if="item.image || Images.product_image"
              @click.stop="
                openImage(item.image || Images.product_image, item.name)
              "
              :src="item.image || Images.product_image"
              :alt="item.name"
              cover
            />
          </v-list-item-avatar>

          <v-list-item-action class="">
            <v-btn
              v-if="canShowAddButton"
              min-width="30"
              min-height="30"
              class="rounded-md position-absolute item_btn"
              color="primary"
              dark
              elevation="0"
              absolute
              @click.stop="setCurrent"
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <!--***-->
      </v-card-text>
    </v-card>

    <product-info-dialog
      v-bind:item="this.item"
      v-bind:dialog="this.details_dialog"
      v-model="details_dialog"
    />
  </div>
  <!--***-->
</template>

<script>
import itemBooking from "@/mixins/itemBooking";
import { createNamespacedHelpers } from "vuex";
import ProductInfoDialog from "@/components/Menu/ProductInfoDialog";

export default {
  components: { ProductInfoDialog },

  mixins: [itemBooking],

  props: {
    item: {
      type: Object,
      required: true
    },
    discount: {
      type: Number,
      default: 0
    },
    categoryId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      details_dialog: false
    };
  },

  computed: {
    ...createNamespacedHelpers("Config").mapGetters([
      "hideProductDetails",
      "productCardStyle",
      "hideProductDescriptionInMenu"
    ]),

    canShowAddButton() {
      return this.isReadonly ? this.isItemHasExtras : true;
    }
  },

  methods: {
    /**
     * show product details dialog
     */
    details() {
      this.details_dialog = true;
    },

    //booking happens in the global dialog, the row only hands the item over
    setCurrent() {
      this.vibrate();

      this.item.discount = this.discount;

      if (this.blockedByGroupLock()) return;
      if (this.blockedByOncePerOrder(this.item)) return;

      if (this.isItemHasExtras) {
        //the dialog reads the category from the item it gets
        this.item.category_id = this.categoryId;
        this.$store.commit("Order/selectCurrent", this.item);
      } else if (!this.isReadonly) {
        this.$store.commit("Order/addToCard", {
          item: { ...this.item, category_id: this.categoryId },
          quantity: 1
        });
        this.$store.commit("Order/selectCurrent", {});
      }
    }
  }
};
</script>

<style scoped>
.item_btn {
  position: absolute !important;
  top: 0px !important;
  right: -1px;
  max-width: 20px !important;
  max-height: 20px !important;
}

.v-list-item__title {
  white-space: normal !important;
}

.item_description {
  display: block !important;
}

#oldPrice {
  text-decoration: line-through;
  font-size: 13px;
  padding-top: 3px;
}

#discounted {
  font-size: 15px;
  font-weight: bold;
  padding-top: 3px;
}
</style>
